import { Modal } from "@mui/material";
import styled from "styled-components";
import Colors from "../../../../../../constants/Colors";

export const AllergiesCardModal = styled(Modal)<{
  useBackgroundColor?: boolean;
}>`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ useBackgroundColor }) =>
    useBackgroundColor && "background-color: rgba(0, 0, 0, 0.3);"}
`;
export const AllergiesCardModalContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: scroll;
  background-color: #ffffff;
  width: ${(props) => (props.isMobile ? "100%" : "85vw")};
  padding: 10px;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`;

export const ModalAllergiesCardContainer = styled.div`
  padding: 36px 102px;

  @media screen and (max-width: 760px) {
    padding: 10px;
    width: 100%;
  }
`;

export const ModalAllergiesMedicCardContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  gap: 10px;
  width: 100%;
  /* justify-content: center; */
`;

export const ModalAllergiesTextCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalAllergiesTimeCardContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  gap: 10px;
  align-items: center;
`;

export const ModalAllergiesHoursContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  ${Colors.SPM500}
`;

export const ModalAllergiesHourCard = styled.div`
  display: flex;

  border-radius: 4px;

  text-align: center;
  @media screen and (max-width: 760px) {
    text-align: left;
  }
  background: ${Colors.SPM50};
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  max-height: 30px;
  gap: 10px;
`;

export const ModalAllergiesSubTextContainer = styled.div`
  text-align: left;
`;

export const ModalAllergiesButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
`;

export const AllergiesModalOverFlow = styled.div<{ isMobile?: boolean }>`
  height: 220px;
  margin-bottom: 50px;
`;
